import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { ChevronDownIcon } from 'components/icons';

import {
  loadMore,
  chevron,
  chevronUp,
  chevronDown,
} from './scss/LoadMore.module.scss';

const LoadMore = ({ onClick, label, className, arrowDirection, isVisible }) =>
  isVisible ? (
    <button className={classNames(loadMore, className)} onClick={onClick}>
      <span>
        {label}{' '}
        <ChevronDownIcon
          className={classNames(
            chevron,
            { up: chevronUp, down: chevronDown }[arrowDirection]
          )}
        />
      </span>
    </button>
  ) : null;

LoadMore.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string,
  arrowDirection: PropTypes.oneOf(['up', 'down']),
  isVisible: PropTypes.bool,
};

LoadMore.defaultProps = {
  onClick: () => {},
  className: '',
  arrowDirection: 'down',
  isVisible: false,
};

export default LoadMore;
